
// import { useState, useEffect, useRef } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import {
//   ChevronDownIcon,
//   ChevronRightIcon,
//   ChevronLeftIcon,
// } from "@heroicons/react/24/solid";
// import { sidebarMenu } from "../../data/sidebarMenu";
// import { FiMenu } from "react-icons/fi";

// export default function Sidebar({
//   setActiveSection,
//   isOpen,
//   onClose,
//   desktopCollapsed = false,
//   onToggleDesktopCollapse,
// }) {
//   const [openIndexes, setOpenIndexes] = useState({});
//   const [activePath, setActivePath] = useState(null);

//   const navigate = useNavigate();
//   const { section } = useParams();
//   const location = useLocation();
//   const sidebarRef = useRef(null);

//   const toggle = (path) => {
//     setOpenIndexes((prev) => ({
//       ...prev,
//       [path]: !prev[path],
//     }));
//   };

//   useEffect(() => {
//     if (!section) return;

//     const findAndOpen = (items, path = "") => {
//       for (let i = 0; i < items.length; i++) {
//         const item = items[i];
//         const key = path ? `${path}-${i}` : `${i}`;

//         if (item.section === section) {
//           setActivePath(key);

//           const parts = key.split("-");
//           const open = {};
//           parts.forEach((_, idx) => {
//             const parentKey = parts.slice(0, idx + 1).join("-");
//             open[parentKey] = true;
//           });

//           setOpenIndexes(open);
//           return true;
//         }

//         if (item.items && findAndOpen(item.items, key)) {
//           return true;
//         }
//       }
//       return false;
//     };

//     findAndOpen(sidebarMenu);
//     setActiveSection(section);
//   }, [section, setActiveSection]);

//   useEffect(() => {
//     const handleOutsideClick = (e) => {
//       if (desktopCollapsed) return;
//       if (window.innerWidth < 1024) return;

//       // Check if the click is outside the sidebar
//       if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
//         // SAFEGUARD: If the user is clicking the toggle/menu button, DO NOT auto-collapse
//         if (
//           e.target.closest('[aria-label="Expand sidebar"]') ||
//           e.target.closest('[aria-label="Collapse sidebar"]')
//         ) {
//           return;
//         }

//         // If clicking a card or action tile, prioritize routing with a minor delay
//         if (
//           e.target.closest(".card") ||
//           e.target.closest(".provider-tile") ||
//           e.target.closest("main button")
//         ) {
//           if (onToggleDesktopCollapse) {
//             setTimeout(() => {
//               onToggleDesktopCollapse();
//             }, 50);
//           }
//           return;
//         }

//         // Default outside click background behavior
//         if (onToggleDesktopCollapse) {
//           onToggleDesktopCollapse();
//         }
//       }
//     };

//     document.addEventListener("click", handleOutsideClick);
//     return () => {
//       document.removeEventListener("click", handleOutsideClick);
//     };
//   }, [desktopCollapsed, onToggleDesktopCollapse]);

//   // NEW: keep sidebar highlight in sync with the actual route
//   useEffect(() => {
//     const currentPath = location.pathname;

//     const findAndOpenByRoute = (items, path = "") => {
//       for (let i = 0; i < items.length; i++) {
//         const item = items[i];
//         const key = path ? `${path}-${i}` : `${i}`;

//         const itemRoute = item.path || (item.section ? `/${item.section}` : null);

//         if (itemRoute === currentPath) {
//           setActivePath(key);

//           const parts = key.split("-");
//           const open = {};
//           parts.forEach((_, idx) => {
//             const parentKey = parts.slice(0, idx + 1).join("-");
//             open[parentKey] = true;
//           });

//           setOpenIndexes(open);

//           if (item.section) {
//             setActiveSection(item.section);
//           }

//           return true;
//         }

//         if (item.items && findAndOpenByRoute(item.items, key)) {
//           return true;
//         }
//       }
//       return false;
//     };

//     findAndOpenByRoute(sidebarMenu);
//   }, [location.pathname, setActiveSection]);

//   const navButtonBase =
//     "w-full flex items-center mb-1 text-sm font-medium rounded-md transition-colors " +
//     "focus:outline-none focus:ring-0 active:outline-none";

//   const activeClasses =
//     "bg-gradient-to-r from-orange-100 to-red-200 dark:from-orange-500 dark:to-red-600 " +
//     "dark:text-white text-text-main";

//   const inactiveClasses =
//     "text-text-muted border-transparent hover:text-black hover:border-gray-300 " +
//     "hover:bg-gradient-to-r hover:from-orange-100 hover:to-red-200 " +
//     "dark:hover:from-orange-500 dark:hover:to-red-600";

//   const NewBadge = () => (
//     <span className="ml-1.5 shrink-0 whitespace-nowrap text-[9px] font-bold uppercase tracking-wide text-white bg-orange-500 dark:bg-white dark:text-black px-1.5 py-0.5 rounded-full leading-none">
//       New
//     </span>
//   );

//   const renderItems = (items, path = "") => {
//     return items.map((item, idx) => {
//       const key = path ? `${path}-${idx}` : `${idx}`;
//       const isItemOpen = openIndexes[key];
//       const isActive = activePath === key;
//       const hasChildren = !!(item.items && item.items.length > 0);

//       if (!hasChildren) {
//         return (
//           <button
//             key={key}
//             onClick={() => {
//               if (onClose) onClose();
//               setActivePath(key);

//               if (item.path) {
//                 navigate(item.path);
//               } else if (item.section) {
//                 setActiveSection(item.section);
//                 navigate(`/${item.section}`);
//               }
//             }}
//             className={`${navButtonBase} ${
//               desktopCollapsed
//                 ? "justify-center px-0 py-2.5"
//                 : "justify-start gap-2 px-3 py-1.5"
//             } ${isActive ? activeClasses : inactiveClasses}`}
//           >
//             {item.icon && (
//               <span className="shrink-0 flex items-center justify-center text-[16px] leading-none">
//                 {item.icon}
//               </span>
//             )}

//             {!desktopCollapsed && (
//               <span className="flex items-center min-w-0 gap-0">
//                 <span className="truncate">{item.title}</span>
//                 {item.isNew && <NewBadge />}
//               </span>
//             )}
//           </button>
//         );
//       }

//       return (
//         <div key={key} className="ml-0.5">
//           <button
//             onClick={() => {
//               if (desktopCollapsed && onToggleDesktopCollapse) {
//                 onToggleDesktopCollapse();
//               }

//               toggle(key);
//               setActivePath(key);

//               if (item.path) {
//                 navigate(item.path);
//               } else if (item.section) {
//                 setActiveSection(item.section);
//                 navigate(`/${item.section}`);
//               }
//             }}
//             className={`${navButtonBase} ${
//               desktopCollapsed
//                 ? "justify-center px-0 py-2.5"
//                 : "justify-between px-3 py-2"
//             } ${isActive ? activeClasses : inactiveClasses}`}
//           >
//             <span
//               className={`flex items-center min-w-0 ${
//                 desktopCollapsed ? "w-full justify-center" : "gap-2"
//               }`}
//             >
//               {item.icon && (
//                 <span className="shrink-0 flex items-center justify-center text-[16px] leading-none">
//                   {item.icon}
//                 </span>
//               )}
//               {!desktopCollapsed && (
//                 <span className="flex items-center min-w-0 gap-0">
//                   <span className="truncate">{item.title}</span>
//                   {item.isNew && <NewBadge />}
//                 </span>
//               )}
//             </span>

//             {!desktopCollapsed && (
//               <span className="shrink-0 ml-2">
//                 {isItemOpen ? (
//                   <ChevronDownIcon className="w-4 h-4 text-gray-400" />
//                 ) : (
//                   <ChevronRightIcon className="w-4 h-4 text-gray-400" />
//                 )}
//               </span>
//             )}
//           </button>

//           {!desktopCollapsed && hasChildren && isItemOpen && (
//             <div className="ml-4 flex flex-col mt-0.5 border-l border-gray-200 dark:border-gray-700">
//               {renderItems(item.items, key)}
//             </div>
//           )}
//         </div>
//       );
//     });
//   };

//   return (
//     <>
//       {isOpen && (
//         <div
//           className="fixed inset-0 bg-black/40 z-40 lg:hidden"
//           onClick={onClose}
//         />
//       )}

//       <aside
//         ref={sidebarRef}
//         className={`
//           fixed top-0 left-0 z-50
//           h-full w-72 hide-scrollbar
//           bg-white dark:bg-[#0f0f0f]
//           border-r border-gray-200 dark:border-gray-800
//           transform transition-all duration-300

//           ${isOpen ? "translate-x-0" : "-translate-x-full"}

//           lg:top-16
//           lg:h-[calc(100vh-4rem)]
//           lg:fixed
//           lg:translate-x-0 lg:opacity-100 lg:pointer-events-auto

//           ${desktopCollapsed ? "lg:w-16 lg:px-2" : "lg:w-72 lg:px-4"}
//           ${desktopCollapsed ? "lg:py-4" : "lg:py-4"}

//           flex flex-col overflow-y-auto p-4 gap-1
//         `}
//       >
//         {/* SECTION TITLE */}
//         <div
//           className={`mb-6 mt-4 flex w-full items-center ${
//             desktopCollapsed ? "px-0 justify-center" : "px-2 justify-between"
//           }`}
//         >
//           {!desktopCollapsed && (
//             <div className="flex-1">
//               <h2 className="text-xs font-semibold tracking-wider uppercase text-gray-400 dark:text-gray-500 mb-2">
//                 Essentials
//               </h2>

//               <div className="relative h-[2px] w-full overflow-hidden">
//                 <div
//                   className="
//                     h-full rounded-full animate-expandLine
//                     bg-gradient-to-r
//                     from-orange-100 to-red-200
//                     dark:from-orange-500 dark:to-red-600
//                     [clip-path:polygon(5%_0%,95%_0%,100%_50%,95%_100%,5%_100%,0%_50%)]
//                   "
//                 />
//               </div>
//             </div>
//           )}

//           <div className="hidden lg:block relative group">
//   <button
//     onClick={(e) => {
//       e.stopPropagation(); // Stops the global click listener from resetting this action
//       onToggleDesktopCollapse();
//     }}
//     className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md
//       transition-colors
//       hover:bg-gray-100 dark:hover:bg-gray-800"
//     aria-label={desktopCollapsed ? "Expand sidebar" : "Collapse sidebar"}
//   >
//     {desktopCollapsed ? (
//       <FiMenu className="w-4 h-4 text-gray-500" />
//     ) : (
//       <ChevronLeftIcon className="w-4 h-4 text-gray-500" />
//     )}
//   </button>

//   <span
//     className={`pointer-events-none absolute top-full mt-2
//       whitespace-nowrap rounded-md bg-gray-900 text-white text-xs px-2 py-1
//       opacity-0 group-hover:opacity-100 transition-opacity z-50
//       ${desktopCollapsed ? "left-1/2 -translate-x-1/2" : "right-0"}`}
//   >
//     {desktopCollapsed ? "Expand" : "Collapse"}
//   </span>
// </div>
//         </div>

//         {/* MENU ITEMS */}
//         <div className="flex flex-col gap-1">
//           {renderItems(sidebarMenu)}
//         </div>
//       </aside>
//     </>
//   );
// }


import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
} from "@heroicons/react/24/solid";
import { sidebarMenu } from "../../data/sidebarMenu";
import { FiMenu } from "react-icons/fi";

// Survive unmount/remount (e.g. when focus mode hides the sidebar)
let lastActivePath = null;
let lastOpenIndexes = {};

export default function Sidebar({
  setActiveSection,
  isOpen,
  onClose,
  desktopCollapsed = false,
  onToggleDesktopCollapse,
}) {
  const [openIndexes, setOpenIndexes] = useState(lastOpenIndexes);
  const [activePath, setActivePath] = useState(lastActivePath);

  const navigate = useNavigate();
  const { section } = useParams();
  const location = useLocation();
  const sidebarRef = useRef(null);

  // Keep the remembered values in sync
  useEffect(() => {
    lastActivePath = activePath;
    lastOpenIndexes = openIndexes;
  }, [activePath, openIndexes]);

  const toggle = (path) => {
    setOpenIndexes((prev) => ({
      ...prev,
      [path]: !prev[path],
    }));
  };

  useEffect(() => {
    if (!section) return;

    const findAndOpen = (items, path = "") => {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const key = path ? `${path}-${i}` : `${i}`;

        if (item.section === section) {
          setActivePath(key);

          const parts = key.split("-");
          const open = {};
          parts.forEach((_, idx) => {
            const parentKey = parts.slice(0, idx + 1).join("-");
            open[parentKey] = true;
          });

          setOpenIndexes(open);
          return true;
        }

        if (item.items && findAndOpen(item.items, key)) {
          return true;
        }
      }
      return false;
    };

    findAndOpen(sidebarMenu);
    setActiveSection(section);
  }, [section, setActiveSection]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (desktopCollapsed) return;
      if (window.innerWidth < 1024) return;

      // Clicks inside the TOC (Focus switch, collapse, etc.) must not collapse the sidebar
      if (e.target.closest("[data-toc]")) return;

      // Check if the click is outside the sidebar
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        // SAFEGUARD: If the user is clicking the toggle/menu button, DO NOT auto-collapse
        if (
          e.target.closest('[aria-label="Expand sidebar"]') ||
          e.target.closest('[aria-label="Collapse sidebar"]')
        ) {
          return;
        }

        // If clicking a card or action tile, prioritize routing with a minor delay
        if (
          e.target.closest(".card") ||
          e.target.closest(".provider-tile") ||
          e.target.closest("main button")
        ) {
          if (onToggleDesktopCollapse) {
            setTimeout(() => {
              onToggleDesktopCollapse();
            }, 50);
          }
          return;
        }

        // Default outside click background behavior
        if (onToggleDesktopCollapse) {
          onToggleDesktopCollapse();
        }
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [desktopCollapsed, onToggleDesktopCollapse]);

  // keep sidebar highlight in sync with the actual route
  useEffect(() => {
    const currentPath = location.pathname;

    const findAndOpenByRoute = (items, path = "") => {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const key = path ? `${path}-${i}` : `${i}`;

        const itemRoute = item.path || (item.section ? `/${item.section}` : null);

        if (itemRoute === currentPath) {
          setActivePath(key);

          const parts = key.split("-");
          const open = {};
          parts.forEach((_, idx) => {
            const parentKey = parts.slice(0, idx + 1).join("-");
            open[parentKey] = true;
          });

          setOpenIndexes(open);

          if (item.section) {
            setActiveSection(item.section);
          }

          return true;
        }

        if (item.items && findAndOpenByRoute(item.items, key)) {
          return true;
        }
      }
      return false;
    };

    findAndOpenByRoute(sidebarMenu);
  }, [location.pathname, setActiveSection]);

  const navButtonBase =
    "w-full flex items-center mb-1 text-sm font-medium rounded-md transition-colors " +
    "focus:outline-none focus:ring-0 active:outline-none";

  const activeClasses =
    "bg-gradient-to-r from-orange-100 to-red-200 dark:from-orange-500 dark:to-red-600 " +
    "dark:text-white text-text-main";

  const inactiveClasses =
    "text-text-muted border-transparent hover:text-black hover:border-gray-300 " +
    "hover:bg-gradient-to-r hover:from-orange-100 hover:to-red-200 " +
    "dark:hover:from-orange-500 dark:hover:to-red-600";

  const NewBadge = () => (
    <span className="ml-1.5 shrink-0 whitespace-nowrap text-[9px] font-bold uppercase tracking-wide text-white bg-orange-500 dark:bg-white dark:text-black px-1.5 py-0.5 rounded-full leading-none">
      New
    </span>
  );

  const renderItems = (items, path = "") => {
    return items.map((item, idx) => {
      const key = path ? `${path}-${idx}` : `${idx}`;
      const isItemOpen = openIndexes[key];
      const isActive = activePath === key;
      const hasChildren = !!(item.items && item.items.length > 0);

      if (!hasChildren) {
        return (
          <button
            key={key}
            onClick={() => {
              if (onClose) onClose();
              setActivePath(key);

              if (item.path) {
                navigate(item.path);
              } else if (item.section) {
                setActiveSection(item.section);
                navigate(`/${item.section}`);
              }
            }}
            className={`${navButtonBase} ${
              desktopCollapsed
                ? "justify-center px-0 py-2.5"
                : "justify-start gap-2 px-3 py-1.5"
            } ${isActive ? activeClasses : inactiveClasses}`}
          >
            {item.icon && (
              <span className="shrink-0 flex items-center justify-center text-[16px] leading-none">
                {item.icon}
              </span>
            )}

            {!desktopCollapsed && (
              <span className="flex items-center min-w-0 gap-0">
                <span className="truncate">{item.title}</span>
                {item.isNew && <NewBadge />}
              </span>
            )}
          </button>
        );
      }

      return (
        <div key={key} className="ml-0.5">
          <button
            onClick={() => {
              if (desktopCollapsed && onToggleDesktopCollapse) {
                onToggleDesktopCollapse();
              }

              toggle(key);
              setActivePath(key);

              if (item.path) {
                navigate(item.path);
              } else if (item.section) {
                setActiveSection(item.section);
                navigate(`/${item.section}`);
              }
            }}
            className={`${navButtonBase} ${
              desktopCollapsed
                ? "justify-center px-0 py-2.5"
                : "justify-between px-3 py-2"
            } ${isActive ? activeClasses : inactiveClasses}`}
          >
            <span
              className={`flex items-center min-w-0 ${
                desktopCollapsed ? "w-full justify-center" : "gap-2"
              }`}
            >
              {item.icon && (
                <span className="shrink-0 flex items-center justify-center text-[16px] leading-none">
                  {item.icon}
                </span>
              )}
              {!desktopCollapsed && (
                <span className="flex items-center min-w-0 gap-0">
                  <span className="truncate">{item.title}</span>
                  {item.isNew && <NewBadge />}
                </span>
              )}
            </span>

            {!desktopCollapsed && (
              <span className="shrink-0 ml-2">
                {isItemOpen ? (
                  <ChevronDownIcon className="w-4 h-4 text-gray-400" />
                ) : (
                  <ChevronRightIcon className="w-4 h-4 text-gray-400" />
                )}
              </span>
            )}
          </button>

          {!desktopCollapsed && hasChildren && isItemOpen && (
            <div className="ml-4 flex flex-col mt-0.5 border-l border-gray-200 dark:border-gray-700">
              {renderItems(item.items, key)}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      <aside
        ref={sidebarRef}
        className={`
          fixed top-0 left-0 z-50
          h-full w-72 hide-scrollbar
          bg-white dark:bg-[#0f0f0f]
          border-r border-gray-200 dark:border-gray-800
          transform transition-all duration-300

          ${isOpen ? "translate-x-0" : "-translate-x-full"}

          lg:top-16
          lg:h-[calc(100vh-4rem)]
          lg:fixed
          lg:translate-x-0 lg:opacity-100 lg:pointer-events-auto

          ${desktopCollapsed ? "lg:w-16 lg:px-2" : "lg:w-72 lg:px-4"}
          ${desktopCollapsed ? "lg:py-4" : "lg:py-4"}

          flex flex-col overflow-y-auto p-4 gap-1
        `}
      >
        {/* SECTION TITLE */}
        <div
          className={`mb-6 mt-4 flex w-full items-center ${
            desktopCollapsed ? "px-0 justify-center" : "px-2 justify-between"
          }`}
        >
          {!desktopCollapsed && (
            <div className="flex-1">
              <h2 className="text-xs font-semibold tracking-wider uppercase text-gray-400 dark:text-gray-500 mb-2">
                Essentials
              </h2>

              <div className="relative h-[2px] w-full overflow-hidden">
                <div
                  className="
                    h-full rounded-full animate-expandLine
                    bg-gradient-to-r
                    from-orange-100 to-red-200
                    dark:from-orange-500 dark:to-red-600
                    [clip-path:polygon(5%_0%,95%_0%,100%_50%,95%_100%,5%_100%,0%_50%)]
                  "
                />
              </div>
            </div>
          )}

          <div className="hidden lg:block relative group">
            <button
              onClick={(e) => {
                e.stopPropagation(); // Stops the global click listener from resetting this action
                onToggleDesktopCollapse();
              }}
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md
                transition-colors
                hover:bg-gray-100 dark:hover:bg-gray-800"
              aria-label={desktopCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              {desktopCollapsed ? (
                <FiMenu className="w-4 h-4 text-gray-500" />
              ) : (
                <ChevronLeftIcon className="w-4 h-4 text-gray-500" />
              )}
            </button>

            <span
              className={`pointer-events-none absolute top-full mt-2
                whitespace-nowrap rounded-md bg-gray-900 text-white text-xs px-2 py-1
                opacity-0 group-hover:opacity-100 transition-opacity z-50
                ${desktopCollapsed ? "left-1/2 -translate-x-1/2" : "right-0"}`}
            >
              {desktopCollapsed ? "Expand" : "Collapse"}
            </span>
          </div>
        </div>

        {/* MENU ITEMS */}
        <div className="flex flex-col gap-1">
          {renderItems(sidebarMenu)}
        </div>
      </aside>
    </>
  );
}